<template>
    <v-container class="mt-10">
        <!-- Use HeadingWithParagraph Component -->
        <HeadingWithPara :title="'HOT DEALS'" :paragraph="'EXCITING DEALS ENJOY SUPER DISCOUNTS AND'"
            :subText="'COMBO OFFERS ON PRODUCTS AND SERVICES, TAILORED JUST FOR YOU'" />
      <Product />
    </v-container>
</template>

<script setup>
import HeadingWithPara from '@/components/HomeCompoent/HeadingWithPara.vue';
import Product from './Product.vue';

</script>

<style scoped>

</style>